export const categories = [
  { id: 'all', name: '全部文章', slug: 'all', icon: 'ri-apps-line' },
  { id: 'download', name: '下载安装', slug: 'download', icon: 'ri-download-2-line' },
  { id: 'guide', name: '使用指南', slug: 'guide', icon: 'ri-book-open-line' },
  { id: 'security', name: '安全认证', slug: 'security', icon: 'ri-shield-check-line' },
  { id: 'update', name: '版本更新', slug: 'update', icon: 'ri-refresh-line' },
  { id: 'faq-cat', name: '常见问题', slug: 'faq-cat', icon: 'ri-question-line' },
];